import React from "react"
import {Col, Row} from "antd";
import IContentType from "../../../../model/interface/dataStorage/IContentType";
import {RestAggregation} from "../../../../model/interface/api/IRestServiceCollectionResponse";
import DataStorageHelper from "../../../../utils/DataStorageHelper";
import IBaseProps from "../../../../model/interface/IBaseProps";
import IAggregationOptions, {
    VIEW_AGGREGATION_PLACEMENT
} from "../../../../model/interface/dataStorage/view/table/IAggregationOptions";
import {humanTime} from "../../file-manager/utils/TimeDuration";
import AggregationProperties from "../../configuration/view/properties/AggregationProperties";
import LocaleText from "../../settings/dictionary/LocaleText";
import { IAppState } from "redux/store";
import selectors from "../../../../redux/selectors";
import {connect} from "react-redux";

export interface IProps extends IBaseProps {
    contentType: IContentType,
    aggregations?: RestAggregation[],
    options?: IAggregationOptions
    placement ?: string
    getText: (code: string, fallBack?: string) => string
    isMobile?: boolean
}

interface IState {
}

class Aggregations extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {}
    }

    render() {
        const {contentType, aggregations, history, options, placement, getText, isMobile} = this.props

        return options && Object.entries(options).filter(([,a]) => (!a.placement && placement === VIEW_AGGREGATION_PLACEMENT.MIDDLE) || a.placement?.includes(placement)).length > 0 ? <Row gutter={[8, 8]} className={'mb-2'}>
            {Object.entries(options).filter(([,a]) => (!a.placement && placement === VIEW_AGGREGATION_PLACEMENT.MIDDLE) || a.placement?.includes(placement)).map(([, aggregation]) => {
                const field = contentType.fields.find(f => f.name === aggregation.field)
                const found = aggregations?.find(a => a.type === aggregation.type && a.field === aggregation.field)
                let value = found && field && DataStorageHelper.buildFieldValue(field, {[found.field]: found.value}, history)
                if (aggregation.format === AggregationProperties.FORMAT_TYPES.HUMAN_TIME) {
                    value = humanTime(found?.value, aggregation.humanTimeFormat?.interval, aggregation.humanTimeFormat?.format.replaceAll('#', ''), getText)
                }
                return found && field && (
                    <Col xs={isMobile ? 24 : undefined} className="ant-statistic">
                        <div className="ant-statistic rounded border p-3" style={{background: aggregation.background}}>
                            <div className="ant-statistic-title" style={{color: aggregation.color}}><LocaleText code={aggregation.title || ''}/></div>
                            <div className="ant-statistic-content font-size-md" style={{color: aggregation.color}}>
                                {value}
                            </div>
                        </div>
                    </Col>
                )
            })}
        </Row> : ''
    }
}

const mapStateToProps = (state: IAppState) => {
    return {
        getText: (code: string, fallback?: string) => selectors.dictionary.getMessage(state, code, fallback),
        isMobile: state.theme.isMobile,
    }
}

export default connect(mapStateToProps)(Aggregations)